export default __webpack_public_path__ + "static/media/clock.887c9075.svg";